import React from 'react';
import { observer } from 'mobx-react';
import { SiteReleaseStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class SiteReleaseCreate extends React.Component {

  onCreate = version => {
    SiteReleaseStore.create({data: {version}});
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a Release Version'
        onCreate={this.onCreate}
      />
    );
  }
}

export default SiteReleaseCreate;
